import { useRef, useLayoutEffect, useMemo } from "react";
import debounce from "lodash.debounce";

export function useDebounce(callback, delay) {
  const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return useMemo(
    () => debounce((...args) => callbackRef.current(...args), delay),
    [delay],
  );
}
